import {
  GSTR9_REPORT_REQUEST,
  GSTR9_REPORT_SUCCESS,
  GSTR9_REPORT_FAILURE,
} from "../types/gstr9-report-types";

const initialState = {
  gstr9Report: {},
  loading: false,
  error: null,
};

const gstr9ReportReducer = (state = initialState, action) => {
  switch (action.type) {
    case GSTR9_REPORT_REQUEST: {
      return {
        ...state,
        loading: true,
        error: null
      };
    }
    case GSTR9_REPORT_SUCCESS: {
      return {
        ...state,
        gstr2Report: {...(action.payload || {})},
        loading: false,
        error: null
      };
    }
    case GSTR9_REPORT_FAILURE: {
      return {
        ...state,
        loading: false,
        error: action.error
      };
    }
    default:
      return state;
  }
};

export default gstr9ReportReducer;
